import {
    ResultOfProjectSummaryVm,
    DocumentManagerDto,
    // DocumentManagerFullDto,
    // DataSourceFileDto,
    // DataSourceFileFullDTO,
    // AspectDto,
    // AspectFullDto,
    // AssetTypeDto,
    // AssetTypeFullDto,
    // AssetTypeVariablesFullDto,
    // AssetDto,
    // ResultOfAssetFullDto,
    // DocumentDto,
    ResultOfPowerBIAccountDto,
    ResultOfIListOfPowerBIAccountDto,
    ResultOfListOfProjectPowerBIObjectDto,
    ResultOfListOfPowerBIWorkspaceVm,
    ResultOfListOfPowerBIWorkspaceObjectVm,
    // WorkOrderDto,
    // GetWorkOrdersQuery,
    // RuleSetDto,
    ResultOfIListOfTeamDto,
    ResultOfTeamDto,
    ResultOfForgeAccountFullDto,
    ResultOfIListOfForgeAccountDto,
    ResultOfListOfString,
    ResultOfListOfBucketObjectVm,
    // ResultOfListOfPropertyCategoryDto,
    ResultOfProjectDto,
    ResultOfIListOfProjectDto,
    ResultOfIListOfRuleSetDto,
    // ResultOfIListOfRuleSetDetailVm,
    ResultOfRuleSetDto,
    ResultOfIListOfForgeObjectDto,
    ResultOfForgeObjectDto,
    // ResultOfListOfAssetDto,
    // ResultOfListOfAssetTypeDto,
    // ResultOfAssetTypeFullDto,
    // ResultOfAssetTypeVariablesFullDto,
    // JsonDocument,
    // ResultOfJsonDocument,
    ResultOfListOfIndexModel,
    ResultOfIReadOnlyCollectionOfCategoryModel,
    ResultOfIListOfDocumentManagerDto,
    ResultOfDocumentManagerFullDto,
    ResultOfAPIResponseModel,
    ResultOfPanelsResponseModel,
    ResultOfAssetsPowerBIReportsModel,
    ResultOfListOfAssetInformationModel,
    ResultOfIListOfProjectPowerAppObjectDto,
    ResultOfProjectPowerBIObjectDto,
    ResultOfDocumentsAssetsApiResponse,
    ResultOfFullAssetInformationModel,
    GetAssetsDbIdsQuery,
    FilterPanelsInfoCommand,
    ResultOfPanelItemsModel,
    ResetFilterPanelsInfoCommand,
    ResultOfAssetControlRulesModel,
    ResultOfAssetControlModel,
    ResultOfAssetsWithDocuments,
    ResultOfExcelPagesModel,
    ResultOfExcelColumnsModel,
    Result,
    ResultOfListOfSignalsInformationModel,
    // ResultOfSignalsModel,
    GetSignalsInformationQuery,
    GetSignalsQuery,
    ResultOfListOfAssetSignalsModel,
    ResultOfTXTRulesModel,
    ResultOfListOfDocumentModel,
} from "./APIClient";
import {
    documentationService,
    forgeService,
    identityService,
    projectsService,
    // dataSourcesService,
    // assetsService,
    assetsInformationService,
    powerBIService,
    // workOrdersService,
    ruleSetsService,
    apiPanelsService,
    powerAppsService,
    assetControlService,
    signalsService,
} from "./Services";

// Forge
export const fetchForgeAccount = (forgeAccountId: string): Promise<ResultOfForgeAccountFullDto> =>
    forgeService.getAccount(forgeAccountId);
export const fetchAccounts = (): Promise<ResultOfIListOfForgeAccountDto> =>
    forgeService.getAllAccounts();

export const fetchBuckets = (forgeAccountId: string): Promise<ResultOfListOfString> =>
    forgeService.getBuckets(forgeAccountId);
export const fetchBucketObjects = (
    accountId: string,
    bucketId: string
): Promise<ResultOfListOfBucketObjectVm> => forgeService.getBucketObjects(accountId, bucketId);
// export const fetchObjectProperties = (
//     forgeObjectId: string
// ): Promise<ResultOfListOfPropertyCategoryDto> =>
//     forgeService.getPropertiesCategories(forgeObjectId);

export const fetchAPICategories = (
    model: string,
    projectId: string
): Promise<ResultOfIReadOnlyCollectionOfCategoryModel> =>
    assetsInformationService.getCategories(model, projectId);
// export const fetchWorkOrders = (
//     model: string
// ): Promise<ResultOfIReadOnlyCollectionOfCategoryModel> =>
//     assetsInformationService.getCategories(model);

// export const fetchWorkOrders = (date: string): Promise<WorkOrderDto[]> =>
//     assetsInformationService.getWorkOrders(date);

// Project
export const fetchProjects = (): Promise<ResultOfIListOfProjectDto> =>
    projectsService.getProjects();
export const fetchProject = (projectId: string): Promise<ResultOfProjectDto> =>
    projectsService.getProject(projectId);
export const fetchProjectSummary = (projectId: string): Promise<ResultOfProjectSummaryVm> =>
    projectsService.getProjectSummary(projectId);
export const fetchProjectForgeObjects = (
    projectId: string
): Promise<ResultOfIListOfForgeObjectDto> => projectsService.getForgeObjects(projectId);

export const fetchProjectUserDefaultDashboard = (
    projectId: string
): Promise<ResultOfProjectPowerBIObjectDto> =>
    projectsService.getProjectUserDefaultDashboard(projectId);

// Panels
export const fetchPanels = (projectId: string): Promise<ResultOfPanelsResponseModel> =>
    apiPanelsService.getPanels(projectId);
export const fetchFilterPanelsInfo = (
    command: FilterPanelsInfoCommand
): Promise<ResultOfPanelItemsModel> => apiPanelsService.filterPanelsInfo(command);
export const fetchResetFilterPanelsInfo = (
    command: ResetFilterPanelsInfoCommand
): Promise<ResultOfPanelItemsModel> => apiPanelsService.resetFilterPanelsInfo(command);
// Models
export const fetchModels = (projectId: string): Promise<ResultOfIListOfForgeObjectDto> =>
    projectsService.getForgeObjects(projectId);
export const fetchModel = (projectId: string, modelId: string): Promise<ResultOfForgeObjectDto> =>
    projectsService.getForgeObject(projectId, modelId);

// // Documentation
export const fetchConnectors = (projectId: string): Promise<ResultOfIListOfDocumentManagerDto> =>
    documentationService.getConnectors(projectId);
export const fetchConnector = (
    projectId: string,
    connectorId: string
): Promise<ResultOfDocumentManagerFullDto> =>
    documentationService.getConnector(connectorId, projectId);
// export const fetchAssetDocumentation = (
//     projectId: string,
//     assetName: string
// ): Promise<DocumentDto[]> => documentationService.getAllDocumentsInAsset(projectId, assetName);

// export const fetchFileDataSources = (projectId: string): Promise<DataSourceFileDto[]> =>
//     dataSourcesService.getFileDataSources(projectId);
// export const fetchFileDataSource = (dataSourceId: string): Promise<DataSourceFileFullDTO> =>
//     dataSourcesService.getFileDataSource(dataSourceId);

// // Aspects
// export const fetchAspects = (): Promise<AspectDto[]> => assetsService.getAspects();
// export const fetchAspect = (aspectId: string): Promise<AspectFullDto> =>
//     assetsService.getAspect(aspectId);

// // AssetTypes
// export const fetchAssetTypes = (): Promise<ResultOfListOfAssetTypeDto> =>
//     assetsService.getAssetTypes();
// export const fetchAssetType = (assetTypeId: string): Promise<ResultOfAssetTypeFullDto> =>
//     assetsService.getAssetType(assetTypeId);
// export const fetchAssetTypeVariables = (
//     assetTypeId: string
// ): Promise<ResultOfAssetTypeVariablesFullDto> => assetsService.getAssetTypeVariables(assetTypeId);

// // Assets
// export const fetchAssets = (projectId: string): Promise<ResultOfListOfAssetDto> =>
//     assetsService.getAssets(projectId);
// export const fetchAsset = (projectId: string, assetName: string): Promise<ResultOfAssetFullDto> =>
//     assetsService.getAsset(projectId, assetName);

// // Work Orders
// export const fetchAllWorkOrders = (projectId: string): Promise<WorkOrderDto[]> =>
//     workOrdersService.getWorkOrders({
//         projectId,
//         firstPlannedDate: "",
//         secondPlannedDate: "",
//     });
// export const fetchWorkOrders = (query: GetWorkOrdersQuery): Promise<WorkOrderDto[]> =>
//     workOrdersService.getWorkOrders(query);
// export const fetchWorkOrder = (workOrderId: string): Promise<WorkOrderDto> =>
//     workOrdersService.getWorkOrder(workOrderId);

// Teams
export const fetchTeams = (projectId: string): Promise<ResultOfIListOfTeamDto> =>
    identityService.getTeams(projectId);
export const fetchTeam = (teamId: string): Promise<ResultOfTeamDto> =>
    identityService.getTeam(teamId);

// export const fetchModelAssetsByExternalId = (
//     projectId: string,
//     forgeObjectId: string,
//     externalId: string
// ): Promise<ResultOfListOfAssetDto> =>
//     assetsService.getModelAssetsByExternalId(projectId, forgeObjectId, externalId);

// export const fetchAssetInfo = (id: string): Promise<ResultOfJsonDocument> =>
//     assetsService.getAssetInfo({ id });

export const fetchAssetInformation = (
    projectId: string,
    dbId: number
): Promise<ResultOfFullAssetInformationModel> =>
    assetsInformationService.getAssetInformation(projectId, dbId);

export const fetchAssetAndPowerBI = (
    projectId: string
): Promise<ResultOfAssetsPowerBIReportsModel> =>
    assetsInformationService.getAssetsPowerBIReports(projectId);

export const fetchAssetInformationByTag = (
    projectId: string,
    tag: string
): Promise<ResultOfFullAssetInformationModel> =>
    assetsInformationService.getAssetInformationByTag(projectId, tag);

export const fetchAssetInformationById = (
    projectId: string,
    id: string
): Promise<ResultOfFullAssetInformationModel> =>
    assetsInformationService.getAssetInformationById(projectId, id);

export const fetchAssetsDbIds = (query: GetAssetsDbIdsQuery): Promise<ResultOfListOfIndexModel> =>
    assetsInformationService.getAssetsDbIds(query);

export const fetchAllAssetInformation = (projectId: string): Promise<ResultOfListOfIndexModel> =>
    assetsInformationService.getAllAssets(projectId);

export const fetchWorkOrders = (plannedDate: Date): Promise<ResultOfAPIResponseModel> =>
    assetsInformationService.getWorkOrders(plannedDate);

export const fetchPermitsToWork = (
    projectId: string,
    date?: Date | undefined
): Promise<ResultOfAPIResponseModel> =>
    assetsInformationService.getPermitsToWork({ projectId, date });

// PowerBI
export const fetchPowerBIAccount = (powerBIAccountId: string): Promise<ResultOfPowerBIAccountDto> =>
    powerBIService.getAccount(powerBIAccountId);
export const fetchPowerBIAccounts = (): Promise<ResultOfIListOfPowerBIAccountDto> =>
    powerBIService.getAllAccounts();
export const fetchPowerBIObjects = (
    projectId: string
): Promise<ResultOfListOfProjectPowerBIObjectDto> => powerBIService.getPowerBIObjects(projectId);
export const fetchPowerBIWorkspaces = (
    powerBIAccountId: string
): Promise<ResultOfListOfPowerBIWorkspaceVm> => powerBIService.getWorkspaces(powerBIAccountId);
export const fetchPowerBIWorkspaceObjects = (
    powerBIAccountId: string,
    workspaceId: string
): Promise<ResultOfListOfPowerBIWorkspaceObjectVm> =>
    powerBIService.getWorkspaceObjects(powerBIAccountId, workspaceId);
export const fetchPowerBIReports = (
    projectId: string
): Promise<ResultOfListOfProjectPowerBIObjectDto> => powerBIService.getPowerBIReports(projectId);
export const fetchPowerBIDashboards = (
    projectId: string
): Promise<ResultOfListOfProjectPowerBIObjectDto> => powerBIService.getPowerBIDashboards(projectId);

// Rules
export const fetchPowerBIObjectRuleSets = (
    powerBIObjectId: string
): Promise<ResultOfIListOfRuleSetDto> =>
    ruleSetsService.getPowerBIObjectRuleSets({ ruleSetObjectId: powerBIObjectId });
// export const fetchWorkOrdersRuleSets = (projectId: string): Promise<ResultOfIListOfRuleSetDto> =>
//     ruleSetsService.getWorkOrdersRuleSets({ ruleSetObjectId: projectId });
export const fetchWorkOrdersRuleSet = (ruleSetId: string): Promise<ResultOfRuleSetDto> =>
    ruleSetsService.getRuleSet(ruleSetId);

export const fetchHeatMap = (
    projectId: string,
    date: string | null
): Promise<ResultOfListOfAssetInformationModel> =>
    assetsInformationService.getHeatMap(projectId, date);
export const fetchMonthsWithMeasurements = (projectId: string): Promise<ResultOfListOfString> =>
    assetsInformationService.getMonthsWithMeasurements(projectId);

export const fetchHeatMapByMonth = (
    projectId: string,
    year: string | null,
    month: string | null
): Promise<ResultOfListOfAssetInformationModel> =>
    assetsInformationService.getHeatMapByMonth(projectId, year, month);

export const fetchDatesWithMeasurements = (projectId: string): Promise<ResultOfListOfString> =>
    assetsInformationService.getDatesWithMeasurements(projectId);

export const fetchAllDocuments = (projectId: string): Promise<ResultOfDocumentsAssetsApiResponse> =>
    documentationService.getAllProjectDocuments(projectId);

export const fetchDocumentsByTagApi = (
    projectId: string,
    tag: string | null,
    signal?: AbortSignal | undefined
): Promise<ResultOfDocumentsAssetsApiResponse> =>
    documentationService.getDocumentsByTagApi(projectId, tag);

export const fetchFakeDocuments = (
    type: string | null,
    signal?: AbortSignal | undefined
): Promise<ResultOfListOfDocumentModel> => documentationService.getDocumentsFake(type);

export const fetchAvailableAssetControls = (
    projectId: string
): Promise<ResultOfAssetControlRulesModel> =>
    assetControlService.getAvailableAssetControls(projectId);

export const fetchAssetsWithDocuments = (projectId: string): Promise<ResultOfAssetsWithDocuments> =>
    assetsInformationService.getAssetsWithDocuments(projectId);

export const fetchAssetControl = (
    projectId: string,
    controlId: string,
    vista: boolean
): Promise<ResultOfAssetControlModel> => assetControlService.getAssetControl(projectId, controlId);

// #region PowerApps
export const fetchPowerApps = (
    projectId: string
): Promise<ResultOfIListOfProjectPowerAppObjectDto> => powerAppsService.getPowerApps(projectId);

export const fetchPowerAppsObjects = (
    projectId: string
): Promise<ResultOfIListOfProjectPowerAppObjectDto> => powerAppsService.getPowerApps(projectId);

// Asset Control
export const fetchAssetControlDocumentList = (
    projectId: string | null
): Promise<ResultOfListOfString> => assetControlService.getFileNames(projectId);

export const fetchExcelPages = (
    projectId: string | null,
    fileName: string | null
): Promise<ResultOfExcelPagesModel> => assetControlService.getExcelPages(projectId, fileName);

export const fetchExcelColumns = (
    projectId: string | null,
    fileName: string | null,
    page: string | null
): Promise<ResultOfExcelColumnsModel> =>
    assetControlService.getExcelColumns(projectId, fileName, page);

export const fetchTXTRulesByVista = (
    projectId: string | null,
    idVista: string | null
): Promise<ResultOfTXTRulesModel> => assetControlService.getTXTRulesByVista(projectId, idVista);

// Signals
export const postGroup = (
    projectId: string | null | undefined,
    name: string | null | undefined,
    description: string | null | undefined,
    idsSignals: string[]
): Promise<Result> => signalsService.addGroup(projectId, name, description, idsSignals);

export const fetchSignalsInformation = (
    query: GetSignalsInformationQuery
): Promise<ResultOfListOfSignalsInformationModel> => signalsService.getSignalsInformation(query);

export const fetchSignals = (query: GetSignalsQuery): Promise<ResultOfListOfAssetSignalsModel> =>
    signalsService.getSignals(query);
